import {
  brandBgReducer,
  BrandBgState,
  brandCaptionLowerThirdReducer,
  BrandCaptionLowerThirdState,
  brandLogoReducer,
  BrandLogoState,
  brandOverlayReducer,
  BrandOverlayState,
  brandReducer,
  BrandState as BrandState0
} from "../reducers";

export interface BrandState {
  brand: BrandState0;
  brandBg: BrandBgState;
  brandCaptionLowerThird: BrandCaptionLowerThirdState;
  brandLogo: BrandLogoState;
  brandOverlay: BrandOverlayState;
}

export const BRAND_STORE = "brand";

export const brandStore = {
  brand: brandReducer,
  brandBg: brandBgReducer,
  brandCaptionLowerThird: brandCaptionLowerThirdReducer,
  brandLogo: brandLogoReducer,
  brandOverlay: brandOverlayReducer
};
